import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
import { useBudgetId } from '../../budget/budget-store';
export const useSyncAccountApi = (options) => {
    const api = useApi();
    const queryClient = useQueryClient();
    const budgetId = useBudgetId();
    // api call
    const syncAccountApi = async (data) => {
        await api.post('/account/sync', data);
    };
    const transactionsKey = ['transactions', budgetId];
    const accountsKey = ['accounts', budgetId];
    const simpleFinAccountsKey = ['simple-fin-accounts', budgetId];
    const mutation = useMutation({
        mutationFn: syncAccountApi,
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: transactionsKey });
            await queryClient.invalidateQueries({ queryKey: accountsKey });
            await queryClient.invalidateQueries({ queryKey: simpleFinAccountsKey });
            if (options?.onSuccess) {
                options.onSuccess();
            }
        },
        onError: () => { },
    });
    return {
        mutate: mutation.mutate,
        isPending: mutation.isPending,
    };
};
